import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { getInstallationCompanyLocation } from '../api/user.api'
import { CompanyContactData } from '../models'

interface UserCompanyLocationHook {
  getCompanyLocationData: (companyId: string | number) => Promise<CompanyLocationInfo>
}

interface CompanyLocationInfo {
  hasLocation: boolean
  companyLocation?: CompanyContactData
}
/**
 * This hook provides functions to interact with the company location api
 */
const useUserCompanyLocation = (): UserCompanyLocationHook => {
  const authFetch = useAuthFetchWithResponse()

  /**
   * Gets location data for a company
   * @param companyId
   */
  const getCompanyLocationData = async (companyId: string | number): Promise<CompanyLocationInfo> => {
    const companyLocationResult = await getInstallationCompanyLocation(companyId, authFetch)

    if (companyLocationResult.value) return { hasLocation: true, companyLocation: companyLocationResult.value }
    else return { hasLocation: false }
  }

  return { getCompanyLocationData }
}

export default useUserCompanyLocation
